<template>
    <div class="animated fadeIn">
        <loading :active.sync="disabledField"></loading>
        <notifications group="foo" />
        <b-row class="text-right">
            <b-col cols="6" sm="4" md="2" class="mb-3">
                <b-button size="sm" block v-bind:variant="btnConnectClass()" v-on:click="changeWidgetStatus()" :disabled="btnChangeDisabled()">{{btnConnectText()}}</b-button>
            </b-col>
        </b-row>
        
        <b-row>
            <b-col md="6">
                <b-card>
                    <div slot="header">
                        <b-row >
                            <b-col cols="6" sm="6" md="6">
                                <i class="fa fa-edit"></i><strong> Периодичность покупок</strong>
                            </b-col>
                            <b-col cols="6" sm="6" md="6" class="text-right">
                                <b-button type="submit" right size="sm" variant="" v-on:click="addPeriodCustomers()"><i class="fa fa-plus"></i> Добавить период</b-button>
                            </b-col>
                        </b-row>
                    </div>
                    
                    <b-row class="mb-3" v-for="item in settings.periodCustomers">
                        <b-col md="7"><b-input disabled :value="periodText(item.value)"></b-input></b-col>
                        <b-col md="3"><b-form-input v-model="item.value" type="number"></b-form-input></b-col>
                        <b-col md="2"><b-link href="#" v-on:click="removeCustomersItem(item)"><i class="icon-trash icons"></i> Удалить</b-link></b-col>
                    </b-row>
                </b-card>

                 <b-card>
                    <div slot="header">
                        <b-row >
                            <b-col cols="6" sm="6" md="6">
                                <i class="fa fa-edit"></i><strong> Периодичность Digital Pipeline</strong>
                            </b-col>
                            <b-col cols="6" sm="6" md="6" class="text-right">
                                <b-button type="submit" right size="sm" variant="" v-on:click="addPeriodPipeline()"><i class="fa fa-plus"></i> Добавить период</b-button>
                            </b-col>
                        </b-row>
                    </div>
                    
                    <b-row class="mb-3" v-for="item in settings.periodPipeline">
                        <b-col md="7"><b-input v-model="item.text"></b-input></b-col>
                        <b-col md="3"><b-form-input v-model="item.value" type="number"></b-form-input></b-col>
                        <b-col md="2"><b-link href="#" v-on:click="removePipelineItem(item)"><i class="icon-trash icons"></i> Удалить</b-link></b-col>
                    </b-row>


                    <div slot="footer">
                        <b-button type="submit" :disabled="!widget.isActive" size="sm" variant="primary" v-on:click="saveSettings()"><i class="fa fa-save"></i> Сохранить</b-button>
                    </div>
                </b-card>
            </b-col>

            <b-col md="6">
                <b-card header-tag="header" footer-tag="footer">
                    <div slot="header"> <i class="icon-notebook icons"></i><strong> Описание</strong></div>
                    <p>Настройка полей периодичности</p>
                </b-card>
            </b-col>
        </b-row>

        
  </div>
</template>

<script>
    import WidgetsService from '@/services/WidgetsService'
    import widgetEvents from '@/views/widgets/Widget';

    export default {
        mixins: [
            widgetEvents
        ],
        components: {  }, 
        name: 'PeriodSettings',
        data () {
            return {
                widget: { isActive : false },
                widgetId: '5cee4604082734536acc0e2c',
                settings : {periodCustomers: [], periodPipeline: []},
                disabledField: false,
                onLoad: false,
            }
        },
        created: function () {
            this.getWidget();
        },
        
        methods: {
            addPeriodCustomers : function () {
                this.settings.periodCustomers.push({value: '0'});
            },

            addPeriodPipeline : function () {
                this.settings.periodPipeline.push({text : 'Через 2 минуты', value: '180'});
            },

            periodText : function (value) {
                return `Раз в ${value} дней`;
            },

            removeCustomersItem(item) {
                this.settings.periodCustomers.splice(this.settings.periodCustomers.indexOf(item), 1);
            },

            removePipelineItem(item) {
                this.settings.periodPipeline.splice(this.settings.periodPipeline.indexOf(item), 1);
                this.saveSettings();
            },
        },
    };
    
</script>